/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { CreditScoreRange, AnnualIncome, MostRecentEviction } from '.zenstack/models';
import { CreditScoreRangeSchema } from '../enums/CreditScoreRange.schema';
import { AnnualIncomeSchema } from '../enums/AnnualIncome.schema';
import { MostRecentEvictionSchema } from '../enums/MostRecentEviction.schema';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isEnabled: z.boolean().default(true),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema,
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isEnabled: z.boolean(),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema,
}
).strict();
const relationSchema = z.object({
    leaseTerms: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    leaseTermsId: z.string(),
}
);

/**
 * `TenantScreeningCriteria` schema excluding foreign keys and relations.
 */
export const TenantScreeningCriteriaScalarSchema = baseSchema;


/**
 * `TenantScreeningCriteria` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const TenantScreeningCriteriaSchema = TenantScreeningCriteriaScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const TenantScreeningCriteriaPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const TenantScreeningCriteriaPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isEnabled: z.boolean(),
    creditScoreRange: CreditScoreRangeSchema,
    annualIncome: AnnualIncomeSchema,
    mostRecentEviction: MostRecentEvictionSchema
}).partial().passthrough();


/**
 * `TenantScreeningCriteria` schema for create operations excluding foreign keys and relations.
 */
export const TenantScreeningCriteriaCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, isEnabled: true, creditScoreRange: true, annualIncome: true, mostRecentEviction: true
});


/**
 * `TenantScreeningCriteria` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const TenantScreeningCriteriaCreateSchema = TenantScreeningCriteriaCreateScalarSchema.merge(fkSchema);


/**
 * `TenantScreeningCriteria` schema for update operations excluding foreign keys and relations.
 */
export const TenantScreeningCriteriaUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `TenantScreeningCriteria` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const TenantScreeningCriteriaUpdateSchema = TenantScreeningCriteriaUpdateScalarSchema.merge(fkSchema.partial());

